module.exports = __webpack_public_path__ + "5f44e4c64fcb9e452b1ed06cc612cf7e.svg";